import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "80.765",
  height: "80.181",
  viewBox: "0 0 17.765 15.181"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("g", { "data-name": "Group 5439" }, [
  /*#__PURE__*/_createElementVNode("g", {
    "data-name": "Group 5438",
    style: {"clip-path":"url(#o50g0oj0la)"}
  }, [
    /*#__PURE__*/_createElementVNode("path", {
      "data-name": "Path 8249",
      d: "M16.962 0H.8a.8.8 0 0 0-.8.8v13.578a.8.8 0 0 0 .8.8h16.162a.8.8 0 0 0 .8-.8V.8a.8.8 0 0 0-.8-.8M5.544 13.755a.375.375 0 0 1-.377.375H1.418a.376.376 0 0 1-.377-.375v-1.984a.378.378 0 0 1 .377-.377h3.749a.377.377 0 0 1 .377.377zm0-4.207a.377.377 0 0 1-.377.377H1.418a.378.378 0 0 1-.377-.377V7.564a.378.378 0 0 1 .377-.377h3.749a.377.377 0 0 1 .377.377zm0-4.207a.377.377 0 0 1-.377.377H1.418a.378.378 0 0 1-.377-.377V3.357a.378.378 0 0 1 .377-.377h3.749a.377.377 0 0 1 .377.377zm5.612 8.414a.375.375 0 0 1-.377.375H7.03a.376.376 0 0 1-.377-.375v-1.984a.378.378 0 0 1 .377-.377h3.749a.377.377 0 0 1 .377.377zm0-4.207a.377.377 0 0 1-.377.377H7.03a.378.378 0 0 1-.377-.377V7.564a.378.378 0 0 1 .377-.377h3.749a.377.377 0 0 1 .377.377zm0-4.207a.377.377 0 0 1-.377.377H7.03a.378.378 0 0 1-.377-.377V3.357a.378.378 0 0 1 .377-.377h3.749a.377.377 0 0 1 .377.377zm5.612 8.414a.376.376 0 0 1-.377.375h-3.749a.375.375 0 0 1-.377-.375v-1.984a.377.377 0 0 1 .377-.377h3.749a.378.378 0 0 1 .377.377zm0-4.207a.378.378 0 0 1-.377.377h-3.749a.377.377 0 0 1-.377-.377V7.564a.377.377 0 0 1 .377-.377h3.749a.378.378 0 0 1 .377.377zm0-4.207a.378.378 0 0 1-.377.377h-3.749a.377.377 0 0 1-.377-.377V3.357a.377.377 0 0 1 .377-.377h3.749a.378.378 0 0 1 .377.377z"
    })
  ])
], -1)
const _hoisted_3 = [
  _hoisted_2
]

function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_3]))
}
export default { render };